const Library = () => {
  return (
    <svg width="20" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.814 0C.818 0 0 .794 0 1.773v12.454C0 15.207.814 16 1.819 16h16.362C19.185 16 20 15.204 20 14.223V4.444c0-.983-.816-1.777-1.822-1.777h-8.175L8.716.743C8.44.333 7.81 0 7.308 0H1.814ZM18.18 14.222l-16.363.005-.004-12.45 5.459.005 1.21 1.858a1.83 1.83 0 0 0 1.52.804h8.179l-.001 9.778Z"
        fill="#fff"
      />
    </svg>
  );
};

export default Library;
